import { SelectOption } from "../common/general";

export const statusOptions: SelectOption[] = [
    {value: '0', item: '申請中'},
    {value: '1', item: '承認済'},
    {value: '2', item: '決裁済'},
    {value: '3', item: '確認済'},
    {value: '4', item: '否認'},
];